import { resolveImagePath } from "@jx3box/jx3box-common/js/utils";

export { resolveImagePath };
